import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, BookOpen } from 'lucide-react';
import { volumes, lessonGroups } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-stone-50" data-id="element-303" data-mp="cp0zcd90b28x">
      <div className="max-w-6xl mx-auto" data-id="element-304" data-mp="cnpusb7qlqgr">
        <div className="text-center mb-16" data-id="element-305" data-mp="7owi2l09y3hn">
          <p className="text-rose-700 font-semibold tracking-widest uppercase text-xs mb-3" data-id="element-306" data-mp="7pxt4phaipzd">
            The Complete 6-in-1 Visual Library
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-stone-800" data-id="element-307" data-mp="3c461fwa18bck">
            Six Complete Volumes for Professional Makeup Education
          </h2>
          <p className="text-xl text-rose-800" data-id="element-308" data-mp="3pwvqk9kuxwdw">
            From foundations to advanced artistry — nothing to build from zero.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-309" data-mp="2xdfasrk6fib1">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.featured ? 'border-rose-700 shadow-xl shadow-rose-900/10' : 'border-stone-200'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-310" data-mp="2sevmiki41ufi" data-mpi={index}>
              {volume.featured && <div className="absolute top-6 -right-9 bg-rose-900 text-white font-bold text-xs py-1 px-10 rotate-45 shadow-sm" data-id="element-311" data-mp="20gwxf1z8ix63">
                  MOST USED
                </div>}

              <div className="mb-6 pr-16" data-id="element-312" data-mp="3bw222bixf5sc">
                <div className="text-rose-700 font-bold text-sm uppercase tracking-wider" data-id="element-313" data-mp="3fv1e0g32s2ta">
                  {volume.number}
                </div>
                <h3 className="text-2xl font-serif font-bold leading-tight mt-1 text-stone-800" data-id="element-314" data-mp="1gozqbg6hrfqx">
                  {volume.title}
                </h3>
              </div>

              <p className="text-stone-800 font-medium mb-6 italic border-l-2 border-rose-700/50 pl-4" data-id="element-315" data-mp="1pqg1vr91lnwq">
                {volume.subtitle}
              </p>

              {volume.lead && <p className="text-rose-900 font-semibold mb-4" data-id="element-316" data-mp="x2249clv8tlp">
                  {volume.lead}
                </p>}
              {volume.bulletsLabel && <p className="text-xs font-semibold uppercase tracking-wider text-rose-800 mb-3" data-id="element-317" data-mp="16sd68tlzospy">
                  {volume.bulletsLabel}
                </p>}

              <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 mb-8 flex-grow content-start" data-id="element-318" data-mp="11zttfyv4m1m7">
                {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2" data-id="element-319" data-mp="9e0xo988zn8x">
                    <CheckCircle2 size={16} className="text-rose-700 shrink-0 mt-0.5" aria-hidden="true" data-id="element-320" data-mp="2l0m95tcieje1" />
                    <span className="text-stone-600 text-sm" data-id="element-321" data-mp="2bzwkd9lo1t9t">{bullet}</span>
                  </li>)}
              </ul>

              <div className="bg-stone-100 border border-stone-200 rounded-xl p-4 mt-auto" data-id="element-322" data-mp="2gy7qb98ubjmr">
                <span className="text-rose-900 font-bold block mb-1" data-id="element-323" data-mp="34obv3jxrlpfc">
                  Result:
                </span>
                <p className="text-stone-600 text-sm" data-id="element-324" data-mp="38ovtsrxzl13l">{volume.result}</p>
              </div>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-12 bg-stone-100 border border-stone-200 rounded-2xl p-8" data-id="element-325" data-mp="2zpih7qekfwen">
          <div className="flex items-center gap-3 mb-8" data-id="element-326" data-mp="1yt0cp0jlxscy">
            <BookOpen size={20} className="text-rose-700" aria-hidden="true" data-id="element-327" data-mp="1yrfi5axam9f3" />
            <h3 className="text-lg font-bold text-stone-800" data-id="element-328" data-mp="1urwxmg9dw0cs">
              150 Ready-to-Teach Classes, Already Organized
            </h3>
          </div>
          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-5" data-id="element-329" data-mp="2mjcs0wh6mrdk">
            {lessonGroups.map(group => <li key={group.title} className="border-l-2 border-rose-700/40 pl-4" data-id="element-330" data-mp="2igzq6j5k3dm2">
                <p className="font-bold text-stone-800" data-id="element-331" data-mp="2dgli513yg3o1">{group.title}</p>
                <p className="text-sm text-stone-600" data-id="element-332" data-mp="28i0eerphv1uu">{group.detail}</p>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}